import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import Stack from '@/contents/General/Stack';
import theme from '@/styles/theme';

import CampSiteCard from './CampSiteCard';
import useBrowsingHistory from './useBrowsingHistory';

const CampSiteHistory = ({ campSiteId }: { campSiteId?: string }) => {
  const { campSites: browsingHistoryCampSites } =
    useBrowsingHistory(campSiteId);
  return (
    <>
      {browsingHistoryCampSites.length > 0 && (
        <Box
          sx={{
            padding: `${theme.spacing(5)} ${theme.spacing(3)}`,
            background: theme.palette.white.main,
          }}
        >
          <Box>
            <Typography fontSize={18} fontWeight={700}>
              閲覧履歴
            </Typography>
            <Stack
              space={2}
              sx={{
                overflowX: 'scroll',
                marginTop: theme.spacing(3),
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
            >
              {browsingHistoryCampSites.map((item) => {
                return (
                  <CampSiteCard key={item.id} campSite={item} cardSize="sm" />
                );
              })}
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};
export default CampSiteHistory;
